import {useState, useEffect} from "react";
import {Autocomplete, TextField, useTheme} from "@mui/material";

const PortStatusDropdownComponent = (props) => {
    const {onChange, value, fullWidth, size, customStyles} = props;

    const theme = useTheme();

    const [stateValue, setStateValue] = useState(null);
    const [inputValue, setInputValue] = useState("");


    const portStatusData = [
        "Active",
        "Deactivated"
    ]

    const filteredPortStatusData = portStatusData?.filter((status) => status !== value);

    
    useEffect(() => {
        setStateValue(value || null);
        setInputValue(value || "");  
    }, [value])


    const handleChange = (newValue) => {
        setStateValue(newValue);
        setInputValue(newValue || "");
        onChange(newValue);
    }


    return (
        <>
            <Autocomplete
                disablePortal
                options={filteredPortStatusData}
                getOptionLabel={(option) => option || ""}
                isOptionEqualToValue={(option, value) => option === value}
                fullWidth={fullWidth}
                size={size}
                value={stateValue}
                onChange={(event, newValue) => handleChange(newValue)}
                inputValue={inputValue}
                onInputChange={(event, newInputValue) => setInputValue(newInputValue)}
                noOptionsText="Status not found."
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label="Select port status"
                        slotProps={{
                            input: {
                                ...params.InputProps,
                                endAdornment: (
                                    <>
                                        {params.InputProps.endAdornment}
                                    </>
                                ),
                            },
                        }}
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                borderRadius: "4px", 
                                height: "42px",
                                paddingTop: '6px', 

                                '& input': {
                                    color: theme.typography.main,
                                    fontSize: 16,
                                    fontWeight: 500,

                                    '&::placeholder': {
                                        color: theme.typography.secondary,               
                                        opacity: 0.45,    
                                        fontSize: 15,    
                                        fontWeight: "400 !important",                     
                                    },
                                },

                                '& fieldset': {
                                    borderColor: "#e5edf6",
                                },

                                '&:hover fieldset': {
                                    borderColor: "#e5edf6",
                                },

                                '&.Mui-focused fieldset': {
                                    borderColor: "#253e5a9e",
                                },
                            },
                            '& .MuiInputLabel-root': {
                                color: theme.typography.secondary,               
                                opacity: 0.45,    
                                fontSize: 15,    
                                fontWeight: "400 !important",
                                marginTop: "-5px",
                            },
                        }}
                    />
                )}
                sx={{...customStyles}}
            />
        </>
    )
}

export default PortStatusDropdownComponent